import { Component } from '@angular/core';

@Component({
  selector: 'app-clusters',
  template: `<clusters-list></clusters-list>`,
})
export class ClustersComponent {}
